export default __webpack_public_path__ + "static/media/shopifyNativeConcent2.6368f1fe.svg";